<template>
    <b-modal visible size="xl" scrollable title="Финансовый журнал объединения" @hidden="$emit('close')">
        <b-spinner v-if="loading" small />
        <div v-if="event">
            <p>Объединение карточек {{ payload.employee_ids.join(', ') }} в #{{ payload.survivor_employee_id }}. Сохранённые исходные данные.</p>
            <p v-if="payload.reason">Причина: {{ payload.reason }}</p>
            <div v-if="lines.length" class="table-responsive"><table class="table table-sm table-bordered">
                <thead><tr><th>Строка</th><th>Сотрудник</th><th>Расчёт</th><th>Поправка</th><th>Итого</th><th>Решение</th></tr></thead>
                <tbody><tr v-for="line in lines" :key="line.id"><td>#{{ line.id }}</td><td><EmployeeLink :employee-id="Number(line.employee_id)" :fallback="line.employee_name_snapshot || '#' + line.employee_id" /></td>
                    <td>{{ money(line.calculated_amount_minor) }}</td><td>{{ money(line.manual_adjustment_minor) }}</td><td>{{ money(line.final_amount_minor) }}</td>
                    <td>{{ payload.kind === 'payroll' ? Number(payload.chosen_line_id) === Number(line.id) ? 'Сохранена целиком' : 'Исключена из расчёта; сохранена в этом журнале' : 'Перенос связи с сотрудником' }}</td></tr></tbody>
            </table></div>
            <div v-if="rates.length" class="table-responsive"><table class="table table-sm table-bordered">
                <thead><tr><th>Ставка</th><th>Карточка</th><th>Период</th><th>Область</th><th>Сумма</th><th>Коэффициент</th></tr></thead>
                <tbody><tr v-for="rate in rates" :key="rate.id"><td>#{{ rate.id }}</td><td>#{{ rate.employee_id }}</td><td>{{ rate.effective_from }} — {{ rate.effective_to || 'без окончания' }}</td>
                    <td>{{ rate.location_class }}</td><td>{{ money(rate.rate_minor) }}</td><td>{{ Number(rate.coefficient_bp) / 10000 }}</td></tr></tbody>
            </table></div>
            <p v-for="(decision, index) in payload.decisions || []" :key="index">{{ decision.start || '' }} — {{ decision.end || '' }}: сохранена запись #{{ decision.choice }}. {{ decision.reason }}</p>
        </div>
        <template #modal-footer>
            <div class="w-100"><b-alert v-if="error" show variant="danger" role="alert">{{ error }}</b-alert>
                <div class="d-flex justify-content-end"><b-button v-if="event" size="sm" variant="outline-secondary" class="mr-2" @click="download">Скачать полный снимок</b-button>
                    <b-button size="sm" @click="$emit('close')">Закрыть</b-button></div>
            </div>
        </template>
    </b-modal>
</template>
<script>
import api from '@/utils/api';
import EmployeeLink from '@/components/EmployeeLink.vue';
export default {
    name: 'EmployeeMergeFinancialAudit', components: {EmployeeLink}, props: {eventId: {type: Number, required: true}},
    data: () => ({event: null, error: '', loading: true}),
    computed: {
        payload() {return this.event && this.event.payload || {};},
        lines() {return this.payload.kind === 'payroll' ? this.payload.before || [] : this.payload.payroll_before || [];},
        rates() {return this.payload.kind === 'rates' ? this.payload.before || [] : this.payload.rates_before || [];}
    },
    async created() {
        try {this.event = (await api.get(`/api/payroll/employee-merge-audits/${this.eventId}`, {ignoreModal: true})).data;}
        catch (error) {this.error = error.response && error.response.data && error.response.data.message || 'Не удалось открыть финансовый журнал.';}
        finally {this.loading = false;}
    },
    methods: {
        money(value) {return value == null ? '—' : (Number(value) / 100).toLocaleString('ru-RU', {minimumFractionDigits: 2, maximumFractionDigits: 2});},
        download() {
            const url = URL.createObjectURL(new Blob([JSON.stringify(this.event, null, 2)], {type: 'application/json'}));
            const link = document.createElement('a'); link.href = url; link.download = `employee-merge-audit-${this.eventId}.json`;
            link.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
        }
    }
};
</script>
